import {
  ScreenshotFile,
  ScreenshotTemplateType,
} from "../../../../../../../redux/slices/projects/Types";

export type ScreenshotTemplate = ScreenshotTemplateType;

export type ScreenshotItem = {
  id: string;
  name: string;
  sizeBytes: number;
  url: string | null;
  mimeType?: string;
  file?: File;
};

export type ScreenshotTemplateOption = {
  value: ScreenshotTemplate;
  label: string;
  hint: string;
};

export const SCREENSHOT_TEMPLATES: ScreenshotTemplateOption[] = [
  { value: "mobile_desktop", label: "Mobile + Desktop", hint: "1 mobile · 1 desktop" },
  { value: "two_desktops", label: "2 Desktops", hint: "Side by side" },
  { value: "three_mobile", label: "3 Mobile Screens", hint: "Portrait layout" },
];

export const SCREENSHOT_TEMPLATE_SLOTS: Record<ScreenshotTemplate, number> = {
  mobile_desktop: 2,
  two_desktops: 2,
  three_mobile: 3,
};

export const DEFAULT_SCREENSHOT_TEMPLATE: ScreenshotTemplate = "three_mobile";
export const DEFAULT_SCREENSHOT_MAX_FILES = 10;
export const SCREENSHOT_MIN_FILES = 1;
export const SCREENSHOT_MAX_SIZE_MB = 5;
export const SCREENSHOT_ACCEPTED_TYPES = ["image/png", "image/jpeg"];

export const toScreenshotItem = (file: ScreenshotFile): ScreenshotItem => ({
  id: String(file.ID),
  name: file.file_name,
  sizeBytes: file.size_bytes,
  url: file.view_url,
  mimeType: file.mime_type,
});

export const formatScreenshotSize = (bytes: number): string => {
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  return `${Math.round(bytes / 1024)} KB`;
};
